module.exports = __webpack_public_path__ + "static/media/info.250a03ef.svg";